module.exports = __webpack_public_path__ + "static/media/kv-all-lc-roulette.a97cc6b4.jpeg";